import styled from 'styled-components'

import { color, spacing } from '../../themes'

export const CloseButton = styled.button`
  color: ${color('white')};
  background: transparent;
  height: 48px;
  width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: ${spacing(2)};
  left: ${spacing(2)};
  cursor: pointer;
  z-index: 10;
`
